import SeoLanding from "../components/SeoLanding";

export default function MealPlannerLanding() {
  return (
    <SeoLanding
      title="Free Family Meal Planner — 7-day plans with DRI tracking | NUTRIENT/LAB"
      description="Plan seven days for the whole family with a free meal planner that tracks 40+ nutrients per person, respects allergies and dislikes, and auto-generates kid-safe weekly plans."
      kicker="Free · Family-scale · Kids-safe"
      h1={<>The meal planner<br />that <span className="text-[#C8FF3F]">respects your kids.</span></>}
      toolName="Meal Planner"
      keywords={[
        "meal planner", "family meal planner", "weekly meal planner", "kids meal planner",
        "allergy-friendly meal planner", "DRI meal planner", "auto meal planner",
        "meal prep planner", "healthy meal planner", "nutrition meal planner",
      ]}
      intro="Seven days · four slots · up to four people — each with their own DRI, allergies, and dislikes. Auto-plan a whole week in one click, get age-banded kid DRIs, and print a share-card grandparents can follow."
      deepLink="/planner"
      deepCta="Open the meal planner"
      ctaTone="sunny"
      benefits={[
        { h: "Family-scale", d: "Add multiple people. Each gets their own DRI targets and per-person coverage bars." },
        { h: "Auto-plan a week", d: "One click generates seven days that respect every person's allergies and dislikes." },
        { h: "Kids Mode", d: "Age-banded child DRIs, playful UI, choking-hazard flags, and a printable share-card." },
      ]}
      features={[
        { h: "Auto-generate 7 days", d: "AI-scored candidate recipes fill breakfast, lunch, dinner, and snack across the whole family." },
        { h: "Per-person DRI tracking", d: "See daily and weekly coverage of 40+ nutrients per person, with deficit alerts." },
        { h: "Allergy presets", d: "One-tap chips for the 14 internationally required allergens (EU FIC + FDA + Codex)." },
        { h: "Kids-focused view", d: "Playful theme, kid highlight nutrients (protein, calcium, iron, D, fiber, zinc), snack ideas." },
        { h: "Family Sharing Card", d: "Print or share a 1-page card grandparents and sitters can follow at snack time." },
        { h: "Choking hazard flags", d: "Age-banded warnings (toddler, young, tween, teen) following AAP guidance." },
      ]}
      faqs={[
        { q: "How many people can I plan for?", a: "Up to four people per plan, each with their own DRI profile (adult, senior, child, teen, pregnant, lactating), allergies, and dislikes." },
        { q: "Does the meal planner respect allergies?", a: "Yes — the auto-plan skips any recipe containing ingredients matching a person's allergy or dislike list. All 14 internationally declared allergens are covered by one-tap presets." },
        { q: "What's Kids Mode?", a: "A playful family view that switches to child-specific DRIs (age bands 1-3, 4-8, 9-13, 14-18), flags choking hazards, high sugar and high sodium per age band, and shows kid highlight nutrients. It auto-enables for kid personas." },
        { q: "Can I print my weekly plan?", a: "Yes — click Share Card on any kid plan to open a print-ready 1-page card with the child's DRI coverage, allergy notes, and a 7-day emoji meal grid." },
        { q: "Is the meal planner free?", a: "Yes. No signup, no card. Part of the free NUTRIENT/LAB suite." },
      ]}
    />
  );
}
